module.exports = __webpack_public_path__ + "img/self-portrait.f512d0f5.jpg";